import { RootReduxState, GlobalNotification } from 'types'

import { selectDomainValue } from './ui'

export const selectGlobalNotification = (
    state: RootReduxState
): GlobalNotification => selectDomainValue(state, ['app', 'globalNotification'])
